import { render, staticRenderFns } from "./UsuariosPermissoes.vue?vue&type=template&id=4eab148b&scoped=true&"
import script from "./UsuariosPermissoes.vue?vue&type=script&lang=js&"
export * from "./UsuariosPermissoes.vue?vue&type=script&lang=js&"
import style0 from "./UsuariosPermissoes.vue?vue&type=style&index=0&id=4eab148b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eab148b",
  null
  
)

export default component.exports